<template>
  <div id="NoDataPage">
    <slot name="content">
      <img :src="imageUrl" class="no_data_img" :style="{ width: `${imageWidth}px`, height: 'auto' }" />
      <div class="tip_title">{{ $t('propTrade.reminder.title') }}</div>
      <div class="tip_text">{{ tips }}</div>
      <div>
        <el-button class="blue_button" type="primary" @click="completeApplication">{{ $t('propTrade.button.completeApplication') }}</el-button>
      </div>
    </slot>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NoDataPage',
  props: {
    imageUrl: {
      type: String
    },
    imageWidth: {
      type: Number,
      default: 154
    },
    tips: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    async completeApplication() {
      await this.$router.push({ name: 'register' }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
#NoDataPage {
  width: 100%;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff !important;
  border-radius: 20px;
  .no_data_img {
    width: 150px;
    height: auto;
  }
  .tip_title {
    font-size: 20px;
    font-weight: 600;
    color: $primary-dark-blue;
    line-height: 20px;
  }
  .tip_text {
    font-size: 14px;
    color: $primary-dark-blue;
    line-height: 20px;
    margin: 24px 0 40px 0;
    max-width: 840px;
    text-align: center;
  }
  /deep/ .el-button {
    border-radius: 33px;
  }
}
@media (max-width: 768px) {
  #NoDataPage {
    .tip_text {
      max-width: 300px;
      font-size: 12px;
    }
  }
  .blue_button,
  .white_button {
    margin-bottom: 0;
  }
}
</style>
